// Fonte única dos módulos do KzeroDiary.
// Adicionar/editar uma entrada aqui propaga automaticamente para:
//   - NAV (App.jsx) — barra de navegação e roteamento
//   - PerfisAcesso (Pessoas › Perfis) — editor de permissões
//   - Resumo de permissões (Pessoas › Alunos/Usuários)
// Schema: { id, label, emoji, acoes?, subs?, tipoOpcoes? }
//   - acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos']  (default: ['ver'])
//   - subs:  [{ id, label, acoes }]                           (default: [])
//   - tipoOpcoes: [{ value, label }]                          (campo "tipo" do módulo)

export const MODULOS = [
  {
    id: 'agenda', label: 'Agenda', emoji: '📅',
    acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'],
    subs: [
      { id: 'agenda.CONSULTORIA', label: 'Consultoria',      acoes: ['ver'] },
      { id: 'agenda.TREINAMENTO', label: 'Treinamento',      acoes: ['ver'] },
      { id: 'agenda.REUNIAO',     label: 'Reunião',          acoes: ['ver'] },
      { id: 'agenda.ESTAGIARIA',  label: 'Estagiária',       acoes: ['ver'] },
      { id: 'agenda.EXTERNO',     label: 'Externo',          acoes: ['ver'] },
      { id: 'agenda.PESSOAL',     label: 'Pessoal',          acoes: ['ver'] },
      { id: 'agenda.valores',     label: 'Valores cobrados', acoes: ['ver'] },
    ],
  },
  { id: 'painel', label: 'Painel', emoji: '📊', acoes: ['ver'], subs: [] },
  {
    id: 'pessoas', label: 'Pessoas', emoji: '👥',
    acoes: ['ver'],
    subs: [
      { id: 'pessoas.clientes',  label: 'Clientes',                   acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'pessoas.alunos',    label: 'Alunos (cadastro e acesso)', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'pessoas.usuarios',  label: 'Usuários do Sistema',        acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'pessoas.perfis',    label: 'Perfis de Acesso',           acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
    ],
  },
  {
    id: 'financeiro', label: 'Financeiro', emoji: '💰',
    acoes: ['ver'],
    subs: [
      { id: 'financeiro.fluxo',        label: 'Fluxo de Caixa', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'financeiro.categorias',   label: 'Categorias',     acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'financeiro.recorrencias', label: 'Recorrências',   acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
    ],
  },
  {
    id: 'documentos', label: 'Documentos', emoji: '🗂️',
    acoes: ['ver'],
    subs: [
      { id: 'documentos.anotacoes',  label: 'Anotações',  acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'documentos.reembolsos', label: 'Reembolsos', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'documentos.atas',       label: 'Atas',       acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'documentos.propostas',  label: 'Propostas',  acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
    ],
  },
  { id: 'prospeccao', label: 'Prospecção', emoji: '🎯', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'], subs: [] },
  { id: 'licitacoes', label: 'Licitações',  emoji: '🏛️', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'], subs: [] },
  {
    id: 'relatorios', label: 'Contabilidade', emoji: '🏛',
    acoes: ['ver'],
    subs: [
      { id: 'relatorios.proLabore', label: 'Pró-labore (recibos)', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
    ],
  },
  {
    id: 'ensino', label: 'Ensino', emoji: '🎓',
    acoes: ['ver'],
    subs: [
      { id: 'ensino.cursos',   label: 'Cursos & Turmas',   acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.aulas',    label: 'Aulas',             acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.material', label: 'Material',          acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.questoes', label: 'Banco de Questões', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.testes',   label: 'Testes',            acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.agenda',   label: 'Calendário',        acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.alunos',   label: 'Alunos',            acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
      { id: 'ensino.trilhas',  label: 'Trilhas',           acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'] },
    ],
  },
  { id: 'marketing', label: 'Marketing', emoji: '📢', acoes: ['ver', 'criar', 'editarTodos', 'excluirTodos'], subs: [] },
  {
    id: 'diagnosticoNR1', label: 'Diagnóstico NR-1', emoji: '🔍',
    acoes: ['ver'],
    tipoOpcoes: [
      { value: 'rh',          label: 'RH — Etapa 1 (Diagnóstico RH)' },
      { value: 'funcionario', label: 'Funcionário — Etapa 2 (Pesquisa)' },
      { value: 'gestor',      label: 'Gestor — Todas as etapas' },
    ],
    subs: [],
  },
  { id: 'backup', label: 'Backup', emoji: '⚙️', acoes: ['ver'], subs: [] },
];

// View enxuta usada pela navegação principal e pelo resumo de permissões.
export const NAV_MODULOS = MODULOS.map(({ id, label, emoji }) => ({ id, label, emoji }));
